import { render, staticRenderFns } from "./sucursalesBancarias.vue?vue&type=template&id=362b50dc"
import script from "./sucursalesBancarias.vue?vue&type=script&lang=js"
export * from "./sucursalesBancarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports